
import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import Vas from '../../../Vas';
import '../../../css/LossReport.css';
import { ExtendedButton,MessageBox,SelectField,DateField } from 'component-lib';
import { DateTimeHelper,CheckValues } from 'utils-lib';
import { RequestAjaxClass, ContractsModel, DocumentsModel } from 'models-lib';

var moment = require('moment');
moment().format();

var lostReason;
var downloadClicked = false;

class LossReport extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};      
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.ContractsModel = new ContractsModel([this]);
        this.CustomerId = props.match.params.CustomerId;
        this.CustomerName = props.match.params.CustomerName;
        this.ContractId = props.match.params.ContractId;
        this.DocumentsModel = new DocumentsModel([this],null,this.Request2);
    }

    componentDidMount(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
          $("#LoadingIcon").removeClass().addClass('hide');
        });

        this.Request2.setApiUrl(Vas.ApiUrl);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setAuth(true);
        this.Request2.setErrorHandler(()=>{
          $("#LoadingIcon").removeClass().addClass('hide');
        });

        this.ContractsModel.SetRequest(this.Request);
        this.ContractsModel.GetLostReasons();
        this.setState({ requiredSelectField:this.refs.Reason, requiredField: this.refs.LossDate },()=>{
            $("#LoadingIcon").removeClass().addClass('hide');
        });

        this.showDocumentDownloadButton();
    }

    Save() {
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        let ReasonId = this.state.Reason;
        let cur = DateTimeHelper.StringToDate($('#LossDate').val(),false,localStorage.getItem('vas_language'));
        let LostDate = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00");

        this.Request.setErrorHandler((error)=>{
          $("#LoadingIcon").removeClass().addClass('hide');
          let data = JSON.parse(error.responseText);
          ReactDOM.render(<MessageBox
            AppURL={Vas.ApplicationUrl}
            Message={data.Description}
            Title={Vas.Resources.Labels["LossReport"]} />, document.getElementById('messageContainer'));   
        });
        this.ContractsModel.ContractLost(this.ContractId,ReasonId,LostDate);
    }

    Update(observer)
    {
      let me = this;
        this.setState({},()=>{
          if(observer === "LostReasons"){
            let reasons = [];
            this.ContractsModel.LostReasons.forEach(function(value) {
                let reason = {};
                reason.Ident = value.Id;
                reason.Name = value.Description;
                reasons.push({ Key: reason.Ident , Display: reason.Name });
            });
            if (me.refs){
                if (me.refs.Reason){
                    me.refs.Reason.setState({ Data: reasons });
                }
            }
          }
          else if(observer === "ContractLost"){
            $("#LoadingIcon").removeClass().addClass('hide');
            Vas.GetView('LossReportSuccess', {CustomerId : this.CustomerId, ContractId: this.ContractId, CustomerName : this.CustomerName}, true);
          }

          //Hier das Dokument runterladen, Download nur, wenn der Downloadbutton gedrückt wurde
          if(me.DocumentsModel.Documents.length > 0 && downloadClicked)
          {

            //Das Ergebnis ist ein Bytestream und der MIME-Type des Dokuments
            var fileInformationArray = me.DocumentsModel.base64ToArrayBuffer(me.DocumentsModel.Documents[0],me);

            var sampleArr = fileInformationArray[0];

            var fileType = fileInformationArray[1];

            me.DocumentsModel.saveByteArray(sampleArr,"Verlustdokument." + fileType);
            
            downloadClicked = false;
          }
        });
    }

    checkFields(){

      if(lostReason !== undefined && lostReason.FlagDocumentNeeded && lostReason.DocumentAvailable){

        this.DocumentsModel.GetDocumentById(lostReason.IdDocument);

        downloadClicked = true;

      } else {

        if (this.state.requiredSelectField && this.state.requiredField){
            let count = 2;
            let filled = 0;

            if (this.state.requiredField){
                if (document.getElementById(this.state.requiredField.props.Id).value.length > 0){
                    filled++;
                }
            }
            
            if (this.state.requiredSelectField){
                if (document.getElementById(this.state.requiredSelectField.props.Id).selectedIndex > 0){
                    filled++;
                }
            }

            if (filled < count){
                let docs=document.querySelectorAll('select,input');
                let docRefs = this.refs;
                CheckValues.checkAllFields(docs,docRefs,"");
                ReactDOM.render(<MessageBox
                  Message={Vas.Resources.Labels["NotAllFields"]}
                  Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
            } else {
                this.Save();
            }
        }
      }
    }

    Close(){
      Vas.GetView("ContractCardContractData",{ Id:this.ContractId, CustomerId: this.CustomerId, CustomerName: this.CustomerName },true);
    }

    showDocumentDownloadButton(){//Methode um die Buttons für die Vertragskündigung bzw. den Dokumentendownload ein bzw. auszublenden

      lostReason = this.ContractsModel.LostReasons.find(r => r.Id === this.state.Reason);

      //Wenn Dokument vorhanden, dann Anzeige Button für Dokumentendownload statt Button für Vertragskündigung

      if(lostReason !== undefined && lostReason.FlagDocumentNeeded && lostReason.DocumentAvailable){
        $('#DateLoss').removeClass().addClass('hide');
        $('#LossDocumentHint').removeClass('hide').addClass('display');

        document.getElementById("Lost").innerHTML = Vas.Resources.Labels["Download"];

      }
      else{
        $('#DateLoss').removeClass().addClass('display');
        $('#LossDocumentHint').removeClass('display').addClass('hide');

        document.getElementById("Lost").innerHTML = Vas.Resources.Labels["LossReport"];
      }
    }

    render()
    {   

        let maxValue = moment();
        return (
        <div className={"form"} >
          <table>
            <thead>
              <tr>
                <th colSpan={2} >
                  {Vas.Resources.Labels["LossReport"]}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={2}><SelectField
                  AppURL={Vas.ApplicationUrl}
                  Width={340}
                  ref={"Reason"}
                  Id={"Reason"}
                  Editable={true}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["ChooseCertificateType"]+"*"}
                  OnChange={()=>{if (document.getElementById("Reason").selectedIndex === 0 && this.refs.Reason.state.Data.length === 1) {
                                    document.getElementById("Reason").selectedIndex = 1; 
                                }
                                this.setState({ Reason: $("#Reason").val() });}} /></td>
              </tr>
              <tr id={'DateLoss'}>
                <td><DateField
                  AppURL={Vas.ApplicationUrl}
                  Language={localStorage.getItem("vas_language")}
                  Editable={true}
                  ref={"LossDate"}
                  MaxValue={maxValue}
                  IsRequired={true}
                  Id={"LossDate"}
                  Label={Vas.Resources.Labels["LossDate"]+"*"} 
                  OnBlur={()=>{ this.setState({ LossDate: $("#LossDate").val() });}}
                  DateFalseFormatText={Vas.Resources.Labels["DateFalseFormat"]}
                  FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]} /></td>
              </tr>
              <tr id={'LossDocumentHint'}>
                <td>
                  <div className={'DownloadLossDocumentHint'}>
                    <br/>
                    {Vas.Resources.Labels["DownloadLossDocumentHint1"]} <br/><br/>
                    
                    <div style={{ fontStyle: 'italic', textAlign: 'center', width: '300px' }}>{Vas.Resources.Labels["Address"]}</div> <br/>
                    
                    {Vas.Resources.Labels["DownloadLossDocumentHint2"]} <br/><br/>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={{float:'left'}}><br />{Vas.Resources.Labels["RequiredField"]}</td>
              </tr> 
              <tr>
                <td >
                  <br />
                  <ExtendedButton
                    Id={'Abort'}
                    Usable={true}
                    Text={Vas.Resources.Labels["Cancel"]}
                    Float={'left'}
                    OnClick={()=>{ this.Close();}}
                    Width={120} />
                  <ExtendedButton
                    Id={'Lost'}
                    Usable={true}
                    ref={"btoDone"}
                    Text={Vas.Resources.Labels["Lost"]}
                    Width={120}
                    Float={'left'}
                    OnClick={()=>{ this.checkFields();}} />
                </td>
                <td>   
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
}
export default LossReport;
